import { Component, OnInit, Input } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { AlertCustomSerasaEnum } from "src/app/core/enum/alert-custom-serasa.enum";
import { ApiServiceSerasa } from "src/app/core/services/serasa.service";

@Component({
  selector: "alert-custom-serasa-dialog",
  templateUrl: "./alert-custom-serasa-dialog.component.html",
  styleUrls: ["./alert-custom-serasa-dialog.component.scss"]
})
export class AlertCustomSerasaDialog implements OnInit {
  @Input("icon") icon: AlertCustomSerasaEnum;
  @Input("title") title: string;
  @Input("message") message: string;
  @Input("buttonTheme") buttonTheme: AlertCustomSerasaEnum;
  @Input("buttonText") buttonText: string;
  @Input("boxAlertMessage") boxAlertMessage: string;

  alertCustomSerasaEnum = AlertCustomSerasaEnum;
  update: boolean;
  idPlan: string;

  ngOnInit(): void {}

  constructor(
    public dialogRef: MatDialogRef<AlertCustomSerasaDialog>,
    private apiServiceSerasa: ApiServiceSerasa
  ) {}

  updateSerasa() {
    this.apiServiceSerasa.updateSerasaStatus(this.idPlan).subscribe({
      next: (res: any) => {
        this.dialogRef.close();
      },
      error: res => {
        this.dialogRef.close();
      }
    });
  }
}
